import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import PortalTechImportDownloads from '../components/PortalTechImportDownloads';
import TechnologyPageHeader from '../components/technology/TechnologyPageHeader';
import { useTechnologyEmbedded } from '../hooks/useTechnologyEmbedded';
import PortalBackground from '../components/PortalBackground';

const Workflows = ({ embedded: embeddedProp }) => {
  const { darkMode } = useTheme();
  const embedded = useTechnologyEmbedded(embeddedProp);

  return (
    <div className={embedded ? '' : 'relative p-6 min-h-screen text-gray-900 dark:text-white'}>
      {!embedded && <PortalBackground />}
      <div className={embedded ? '' : 'relative'}>
      {!embedded && <TechnologyPageHeader title="Workflows" />}

      <div className={`bg-white dark:bg-gray-900 border-gray-200 dark:border-gray-800 rounded-lg border p-6 shadow-md`}>
        <p className={darkMode ? 'text-gray-300' : 'text-gray-600'}>
          Workflow JSON files from CRM → Templates → Imports appear below for download.
        </p>
        <PortalTechImportDownloads tabId="workflows" />
      </div>
      </div>
    </div>
  );
};

export default Workflows;
